//ImageImportControlView.js

import { View } from 'backbone';
import eventBus         from 'EventBus.js';
import constants                from 'Constants.js';
import BaseControlView from 'BaseControlView.js';
import template from 'advanced-inputs/control_image_import.ejs';

//=====================================================================
//
// An instance of this view represents an image import control
//
// Maty Rocha, Feburary 26, 2016
//
//=====================================================================
class ImageImportControlView extends BaseControlView  {

    initialize( opts ) {

        super.initialize( opts );

        this.template = template;
        this.subfamily = constants.CONTROL_ATTACHMENTS;
        this.tagName = 'div';

        this.events = {
        };

        this.listenTo(this.model, 'change', this.render);
        this.listenTo( eventBus, 'ButtonThemeChange', this.themeChangeRender);

        return this;
    }

    // Neighbor aligner uses this polymorphic property, looking for
    // value 'BaseStaticTextControl'
    get kind() {
        return 'ImageImportControlView';
    }


}

export default ImageImportControlView;
